(() => {
  'use strict';
  const menuKeys={'brands':'brands','strategy + engineering':'strategy-engineering','manufacturing':'manufacturing','live environments':'live-environments','exo os':'exo-os','contact':'contact'};
  const menuKeyFromLink=link=>menuKeys[link?.textContent?.trim().toLocaleLowerCase()];
  function initHeaderMenus(root=document){
    const header=root.matches?.('[data-exo-header]')?root:root.querySelector('[data-exo-header]');
    const nav=header?.querySelector('[data-header-nav]'),mobile=header?.querySelector('[data-header-mobile-menu]'),mobilePanel=header?.querySelector('[data-header-mobile-menu-links]');
    if(!header||!nav||header.dataset.headerMenusReady==='true')return;
    header.dataset.headerMenusReady='true';
    const mq=matchMedia('(max-width:1240px)'),backdrop=document.createElement('div');
    backdrop.className='exo-menu-backdrop';backdrop.hidden=true;backdrop.setAttribute('aria-hidden','true');header.before(backdrop);
    let sequence=0;
    const visible=el=>!!el?.getClientRects().length;
    const sync=()=>{
      const isMobile=mq.matches&&mobile?.open,active=header.querySelector('[data-header-menu][open]');
      backdrop.hidden=!(isMobile||(!mq.matches&&active));
      document.documentElement.classList.toggle('exo-navigation-locked',!!isMobile);
      header.style.setProperty('--exo-nav-bottom',Math.ceil(header.getBoundingClientRect().bottom)+'px');
      header.querySelectorAll('[data-header-menu], [data-header-mobile-menu]').forEach(menu=>{
        const summary=menu.querySelector(':scope > summary');summary?.setAttribute('aria-expanded',String(menu.open));
      });
      const summary=mobile?.querySelector(':scope > summary');
      summary?.setAttribute('aria-label',isMobile?'Close navigation':'Open navigation');
      const label=header.querySelector('[data-header-mobile-menu-label]');if(label&&label.textContent!=='Menu')label.textContent='Menu';
    };
    const closeMenus=(except,returnFocus=false)=>{
      let previous;
      header.querySelectorAll('[data-header-menu][open], [data-header-mobile-menu][open]').forEach(menu=>{
        if(menu!==except){previous=menu;menu.open=false;}
      });
      sync();if(returnFocus&&previous)previous.querySelector(':scope > summary')?.focus({preventScroll:true});
    };
    const identify=menu=>{
      const summary=menu.querySelector(':scope > summary'),panel=menu.querySelector(':scope > div,:scope > nav');
      if(!summary||!panel)return;if(!panel.id)panel.id='exo-nav-panel-'+(++sequence);
      summary.setAttribute('aria-controls',panel.id);summary.setAttribute('aria-expanded',String(menu.open));
    };
    const installMenus=()=>{
      const isExo=(nav.getAttribute('aria-label')||'').toLowerCase()==='exo navigation';
      if(!isExo){nav.querySelectorAll(':scope > [data-header-menu]').forEach(m=>m.remove());header.classList.remove('has-brand-menu','has-header-menus');sync();return;}
      [...nav.querySelectorAll(':scope > a')].forEach(link=>{
        const key=menuKeyFromLink(link),template=key&&header.querySelector(`[data-header-menu-template][data-header-menu-key="${key}"]`);
        if(template)link.replaceWith(template.content.cloneNode(true));
      });
      const menus=[...nav.querySelectorAll(':scope > [data-header-menu]')];menus.forEach(identify);
      header.classList.toggle('has-header-menus',!!menus.length);header.classList.toggle('has-brand-menu',!!nav.querySelector('[data-header-brand-menu]'));sync();
    };
    const decorateMobile=()=>{
      if(!mobilePanel||mobilePanel.querySelector('.exo-mobile-panel-head'))return;
      const heading=document.createElement('div');heading.className='exo-mobile-panel-head';
      const name=document.createElement('span');name.textContent=mobilePanel.getAttribute('aria-label')?.replace(' mobile navigation','')||'Explore EXOLOX';
      const close=document.createElement('button');close.type='button';close.className='exo-mobile-close';close.textContent='×';close.setAttribute('aria-label','Close navigation');close.onclick=()=>closeMenus(null,true);
      heading.append(name,close);mobilePanel.prepend(heading);
      const footer=document.createElement('div');footer.className='exo-mobile-panel-footer';
      const home=document.createElement('a');home.href='https://exolox.com/';home.textContent='EXOLOX home';
      const account=document.createElement('a');account.href='/account';account.textContent='My account';footer.append(home,account);mobilePanel.append(footer);
      identify(mobile);sync();
    };
    new MutationObserver(installMenus).observe(nav,{childList:true});
    if(mobilePanel)new MutationObserver(decorateMobile).observe(mobilePanel,{childList:true});
    // Native details keep touch and keyboard behavior; shared state handles the
    // backdrop and page lock even when another theme handler closes a menu.
    new MutationObserver(sync).observe(header,{attributes:true,attributeFilter:['open'],subtree:true});
    document.addEventListener('pointerdown',event=>{
      if(!header.contains(event.target))closeMenus();
    });
    header.addEventListener('click',event=>{
      const summary=event.target.closest('[data-header-menu] > summary,[data-header-mobile-menu] > summary');
      if(summary){const menu=summary.parentElement;setTimeout(()=>{if(menu.open)closeMenus(menu);sync();},0);return;}
      const link=event.target.closest('a[href]');
      if(!link||!link.closest('[data-header-menu],[data-header-mobile-menu]'))return;
      const url=new URL(link.href,location.href);
      let target=null;if(url.origin===location.origin&&url.pathname===location.pathname&&url.hash){try{target=document.getElementById(decodeURIComponent(url.hash.slice(1)));}catch{}}
      closeMenus();
      if(target){
        event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
        history.pushState(null,'',url.hash);if(!target.hasAttribute('tabindex')){target.setAttribute('tabindex','-1');target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});}target.focus({preventScroll:true});
      }
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape'){const opened=header.querySelector('[data-header-menu][open],[data-header-mobile-menu][open]');if(opened){event.preventDefault();closeMenus(null,true);}return;}
      if(mq.matches&&mobile?.open&&event.key==='Tab'){
        const controls=[...header.querySelectorAll('a[href],button,summary')].filter(el=>visible(el)&&!el.disabled);
        const first=controls[0],last=controls.at(-1);
        if(event.shiftKey&&(document.activeElement===first||!header.contains(document.activeElement))){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&(document.activeElement===last||!header.contains(document.activeElement))){event.preventDefault();first?.focus();}
      }
    },true);
    nav.addEventListener('keydown',event=>{
      const menu=event.target.closest('[data-header-menu]'),summary=menu?.querySelector(':scope > summary');if(!menu)return;
      if(event.target===summary&&['ArrowDown','ArrowUp'].includes(event.key)){
        event.preventDefault();closeMenus(menu);menu.open=true;sync();const links=menu.querySelectorAll('.adaptive-header__menu-panel a');(event.key==='ArrowUp'?links[links.length-1]:links[0])?.focus();
      }else if(event.target===summary&&['ArrowLeft','ArrowRight'].includes(event.key)){
        event.preventDefault();const summaries=[...nav.querySelectorAll('[data-header-menu] > summary')],i=summaries.indexOf(summary),next=summaries[(i+(event.key==='ArrowRight'?1:-1)+summaries.length)%summaries.length];closeMenus();next?.focus();
      }
    });
    header.addEventListener('focusout',()=>setTimeout(()=>{if(!mq.matches&&!header.contains(document.activeElement))closeMenus();},0));
    window.addEventListener('resize',sync,{passive:true});mq.addEventListener('change',()=>closeMenus());
    installMenus();decorateMobile();identify(mobile);sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initHeaderMenus());else initHeaderMenus();
  document.addEventListener('shopify:section:load',event=>initHeaderMenus(event.target));
})();
